import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import {
  MainWrapper,
  ModalHead,
  ModalFooterNoPadding,
} from './styles'
import Attachments from './Attachments'
import { ContainerButtonModal } from './styles'
import IconPng from 'components/atoms/IconPng/index'
import { ContainerHeader } from './styles'
const ic_cancel = require('App/assets/images/ic_cancel.png')

export class ImportExcelUploadModal extends PureComponent {

  render() {
    return (
      <MainWrapper>
        <ModalHead>
          <ContainerHeader>
            <div>
              <Label lineheight={'29px'} size={'20px'} mb={'0px'}>
                Import Excel
              </Label>
            </div>
            <ButtonReg
              btnTxt={
                <IconPng srcIcon={ic_cancel} size={'auto'} h={'14'} showPointer={true} onClick={this.props.fnSwitch} />
              }
              onClick={this.props.fnSwitch}
              width={'fit-content'}
              height={'34px'}
              transparent
            />
          </ContainerHeader>
        </ModalHead>
        <Attachments {...this.props} />
        <ModalFooterNoPadding>
          <ContainerButtonModal>
            <ButtonReg
              bordered
              onClick={this.props.handleUploadFile}
              disabled={!this.props.importExcelUploadAttachments}
              btnTxt={'Upload File'}
              margin={'0 16px 0 0'}
            />
            <ButtonReg
              onClick={this.props.fnSwitch}
              transparent={true}
              bordered={true}
              btnTxt={'Cancel'}
            />
          </ContainerButtonModal>
        </ModalFooterNoPadding>
      </MainWrapper>
    )
  }
}

export default withTheme(ImportExcelUploadModal)
